import { Component, OnInit } from '@angular/core';
import { LinkComponent } from "./components/link/link.component";
import { HeroComponent } from "./components/hero/hero.component";
import { TextgroupComponent } from "./components/textgroup/textgroup.component";
import { AccordionComponent } from 'src/app/shared/components/accordion/accordion.component';
import { IAccordionItem } from '@interfaces/accordion.interface';

@Component({
  selector: 'aig-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  imports: [LinkComponent, HeroComponent, TextgroupComponent, AccordionComponent ]
})
export class HomePageComponent implements OnInit {

  heroInfo = {
    image : "./assets/images/bg-ciberseguridad.jpg",
    alt: "Imagen top"
  };

  public Faqs: IAccordionItem[] = [
    {
      title : "¿Quién puede contratar el seguro?",
      description : "La póliza podrá ser contratada por empleados o familiares de empleados (cónyuges / parejas de hecho e hijos) de Caixabank.",
      id : 0
    },
    {
      title : "¿Quiénes son los asegurados?",
      description : "El seguro es individual por lo que el asegurado será el tomador de la póliza. Es decir, las coberturas solo son aplicables a la persona que contrata la póliza.",
      id : 1
    },
    {
      title : "Si mañana sufro un incidente, ¿estoy cubierto?",
      description : "Sí, estás cubierto desde el primer día.* <br> <br> El seguro no cubre siniestros ocurridos antes de la fecha de efecto del seguro. <br><br> <ol> <li>Robo de identidad</li> <li>Violación de la privacidad</li> <li>Ciber-extorsión / Ataques ransomware</li> <li>Compra Protegida</li> <li>Cargos Fraudulentos</li>  </ol>",
      html : true,
      id : 2
    },
    {
      title : "¿Cuáles son los riegsos de Internet para mí?",
      description : "Son innumerables: robo de datos bancarios mediante pishing y otros métodos, robo de la identidad, fraude en las compras online, robo de fotografías y vídeos personales, encriptado de la memoria de los dispositivos y petición de rescate, y una larga lista de actividades fraudulentas de las que todos podemos ser víctimas, y de las cuáles el Seguro de Ciberseguridad, te protegerán.",
      id : 3
    },
    {
      title : "¿Cómo funciona la promoción de 3 meses gratis?",
      description : "Aunque el seguro es anual, por ser empleado de Caixabank te descontamos la parte alícuota de 3 meses de seguro el primer año, cobrando el resto de prima del producto (9 meses) al comienzo del cuarto mes de seguro. Por menos de lo que cuesta un café al mes, estarás protegido contra incidentes y fraudes cibernéticos. <br> <br> La prima de las renovaciones o segundas contrataciones por un mismo tomador, no se tendrán en cuenta para aplicar la promoción, cobrándose la prima anual íntegra en la cuenta bancaria designada a tal efecto.",
      html : true,
      id : 4
    },
    {
      title : "¿Cómo tramito el alta y la baja de mi póliza?",
      description : "A través de la plataforma habilitada para ello podrá dar de alta la póliza, modificar sus datos personales o de domiciliación bancaria, así como dar de baja la póliza en el caso de no desear continuar con el seguro. Al ser una póliza con carácter anual, usted podrá comunicar la cancelación de la póliza con un preaviso de 30 días a la finalización del contrato, no renovándose el seguro una vez llegue la fecha de vencimiento.",
      id : 5
    },
    {
      title : "¿Cómo puedo declarar un siniestro?",
      description : "A través del e-mail <a href='mailto:backoffice.caixa@icp.es'>backoffice.caixa@icp.es</a>. Deberá comunicar el siniestro describiendo los hechos ocurridos. En el caso de que los mismos puedan ser objeto de cobertura por la póliza, el equipo de AIG le informará qué documentación debe presentar para estudiar su caso y comprobar si existe cobertura del siniestro.",
      html : true,
      id : 6
    }
  ];

  constructor() {}

  ngOnInit() {
  }

}
